export const PRINT_TEXT = {
  stl: "Daw Hla Tin",
  companyName: "Daw Hla Tin Company Ltd",
  companyAddress: "MDY",
  documentTitle: "Goods Issued & Delivery Note",
  issuedBy: "Issued By",
  deliveredBy: "Delivered By",
  receivedBy: "Received By",
  tableHeaders: [
    "No",
    "Ro No",
    "Item Code",
    "Description",
    "Packing Type",
    "Unit",
    "Qty",
    "Remark",
  ],
  goodIssueTableUtils: {
    headers: {
      no: "NO",
      itemDescription: "Item Description",
      unit: "Unit",
      qty: "Qty",
      mfg: "MFG",
    },
    description: "Description",
    issueBy: "Issued By",
    receiveBy: "Received By",
    username: "User Name",
  },
  receivedCondition: "Above items are received in good condition.",
  sign: "Sign",
  name: "Name",
  position: "Position",

  authorized: "AUTHORIZED BY",
  total_amount: "TOTAL AMOUNT",
  transport_charge: "TRANSPORT CHARGES",
  sale_tax: "SALES TAX",
  less_deposit: "LESS DEPOSIT",
  balance: "BALANCE DUE",
  memo: "MEMO: Consignment Sale",
  slae_invoice_note:
    "Note : Please make sure receiving Official Cash Receipt after each payment",
  invoice_voucher_text_one:
    "ခြံအမှတ်(၁၅၈/A)၊ အောက်ကြည့်မြင်တိုင်လမ်း၊ ဒုတိယသီရိရိပ်သာ၊ အလုံမြို့နယ်၊ ရန်ကုန်မြို့ ဖုန်း - 09420055154",
  invoice_voucher_text_two: "",
  invoice_voucher_text_three:
    "Lashio Branch Tel:09977753661, Mawlamyine Branch Tel:09-73790955,09952877172",
};
